import React, { Component } from "react";
import { connect } from "react-redux";
import NumberFormat from "react-number-format";
import moment from "moment-timezone";

import "../css/orders.css";

// Utils
import nl2br from "../utils/nl2br";

class Order extends Component {

	formatDate(pickupDate) {
		const date = moment(pickupDate, 'YYYY-MM-DD HH:mm:ss');
		const dateString = date.format('MMMM Do YYYY, h:mm a');
		return dateString;
	}

	render() {
		const { order } = this.props;

		// console.log(order);
		// console.log(this.props);

		return (
			<div className="order-summary">
				<div className="container misc-items">
					<span className="order-id">
						<strong>Order ID:</strong>
						<span className="order-id--value">{order.invoiceid}</span>
					</span>
					<span className="hst-number">
						<strong>HST Registration No.</strong>
						<span className="order-id--value">
							{order.cart.hst_registration_number}
						</span>
					</span>
				</div>

				<div className="order-info-wrapper">
					{/* BILLING */}
					<div className="full-section">
						<div className="section">
							<h2>Billing Information</h2>

							<div className="order-info">
								<div>
									<span>First Name:</span> {order.billing_fname}
								</div>
								<div>
									<span>Last Name:</span> {order.billing_lname}
								</div>
								<div>
									<span>Address:</span> {order.billing_address}
								</div>
								{order.billing_address2 && (
									<div>
										<span>Address 2:</span> {order.billing_address2}
									</div>
								)}
								<div>
									<span>City:</span> {order.billing_city}
								</div>
								<div>
									<span>Province:</span> {order.billing_province}
								</div>
								<div>
									<span>Postal/Zip:</span> {order.billing_postal}
								</div>
								<div>
									<span>Phone:</span> {order.billing_phone}
								</div>
								<div>
									<span>Email:</span> {order.email}
								</div>
							</div>
						</div>

						{/* SHIPPING */}
						<div className="section">
							<h2>{order.pickup ? 'Pickup Information' : 'Shipping Information'}</h2>

							<div className="order-info">
								{order.pickup && (
									<div>
										<span>Pickup Date:</span> {this.formatDate(order.pickup)}
									</div>
								)}
								{order.delivery_fname && (
									<div>
										<span>First Name:</span> {order.delivery_fname}
									</div>
								)}
								{order.delivery_lname && (
									<div>
										<span>Last Name:</span> {order.delivery_lname}
									</div>
								)}
								{order.delivery_company && (
									<div>
										<span>Company:</span> {order.delivery_company}
									</div>
								)}
								<div>
									<span>Address:</span> {order.delivery_address}
								</div>
								{order.delivery_address2 && (
									<div>
										<span>Address 2:</span> {order.delivery_address2}
									</div>
								)}
								<div>
									<span>City:</span> {order.delivery_city}
								</div>
								<div>
									<span>Province:</span> {order.delivery_province}
								</div>
								<div>
									<span>Postal/Zip:</span> {order.delivery_postal}
								</div>
								<div>
									<span>Phone:</span> {order.delivery_phone}
								</div>
							</div>
						</div>
					</div>

					{/* PURCHASE INFO */}
					{order.merchant && (
						<div className="section full-section">
							<h2>Purchase Information</h2>

							<div className="order-info">
								<div>
									<span>Amount:</span>{" "}
									<NumberFormat
										value={order.merchant.amount}
										displayType={"text"}
										decimalScale={2}
										fixedDecimalScale={true}
										thousandSeparator={true}
										prefix={"$"}
									/>
								</div>
								<div>
									<span>Processed On:</span> {order.merchant.timestamp} (Local:{" "}
									{order.merchant.date_added})
								</div>
							</div>
						</div>
					)}

					{/* CART ITEMS */}
					<div className="full-section">
						{order.items ? (
							<table className="cart-review-table">
								<thead>
									<tr>
										<th>Item</th>
										<th>Price</th>
										<th className="heading-qty">Qty</th>
										<th className="heading-total">Total</th>
									</tr>
								</thead>
								<tbody>
									{Object.keys(order.items).map(itemKey => {
										const item = order.items[itemKey];

										return [
											<tr
												key={"product-" + itemKey}
												className="item item--product"
											>
												<td className="title">{item.name}</td>
												<td className="item-price">
													<NumberFormat
														value={item.price_final}
														displayType={"text"}
														decimalScale={2}
														fixedDecimalScale={true}
														thousandSeparator={true}
														prefix={"$"}
													/>
												</td>
												<td className="qty">{item.qty}</td>
												<td className="total">
													<NumberFormat
														value={item.total}
														displayType={"text"}
														decimalScale={2}
														fixedDecimalScale={true}
														thousandSeparator={true}
														prefix={"$"}
													/>
												</td>
											</tr>,
											<tr
												key={"variant-" + itemKey}
												className="item item--variant"
											>
												<td colSpan="4" className="title">
													{item.variant ? (
														<div>
															{item.variant.variant_title} -{" "}
															{item.sku}
														</div>
													) : (
															<div>{item.sku}</div>
														)}
												</td>
											</tr>
										];
									})}
								</tbody>
							</table>
						) : (
								<div>No items found</div>
							)}
					</div>
				</div>

				{/* ORDER TOTALS  */}
				<div className="order-info--totals">
					<div className="company-address">
						<div className="company">{order.cart.company}</div>
						<div>{order.cart.address}</div>
						<div>
							{order.cart.city}, {order.cart.province}
						</div>
						<div>{order.cart.postal}</div>
						<div>{order.cart.phone}</div>
					</div>
					<div className="order-totals">
						<div>
							<span className="total-title">Subtotal: </span>
							<span className="total-value">
								<NumberFormat
									value={order.subtotal}
									displayType={"text"}
									decimalScale={2}
									fixedDecimalScale={true}
									thousandSeparator={true}
									prefix={"$"}
								/>
							</span>
						</div>
						<div>
							<span className="total-title">Shipping: </span>
							<span className="total-value">
								<NumberFormat
									value={order.totalshipping}
									displayType={"text"}
									decimalScale={2}
									fixedDecimalScale={true}
									thousandSeparator={true}
									prefix={"$"}
								/>
							</span>
						</div>

						{/* TAXES */}
						{parseFloat(order.totalpst) !== 0 && (
							<div>
								<span className="total-title">PST: </span>
								<span className="total-value">
									<NumberFormat
										value={order.totalpst}
										displayType={"text"}
										decimalScale={2}
										fixedDecimalScale={true}
										thousandSeparator={true}
										prefix={"$"}
									/>
								</span>
							</div>
						)}
						{parseFloat(order.totalgst) !== 0 && (
							<div>
								<span className="total-title">GST: </span>
								<span className="total-value">
									<NumberFormat
										value={order.totalgst}
										displayType={"text"}
										decimalScale={2}
										fixedDecimalScale={true}
										thousandSeparator={true}
										prefix={"$"}
									/>
								</span>
							</div>
						)}
						{parseFloat(order.totalhst) !== 0 && (
							<div>
								<span className="total-title">HST: </span>
								<span className="total-value">
									<NumberFormat
										value={order.totalhst}
										displayType={"text"}
										decimalScale={2}
										fixedDecimalScale={true}
										thousandSeparator={true}
										prefix={"$"}
									/>
								</span>
							</div>
						)}

						<div className="grand-total">
							<span>Total: </span>
							<NumberFormat
								value={order.total_charged}
								displayType={"text"}
								decimalScale={2}
								fixedDecimalScale={true}
								thousandSeparator={true}
								prefix={"$"}
							/>
						</div>
					</div>
				</div>

				{order.notes !== "" && (
					<div className="order-info--notes">
						<h3>Notes to seller</h3>
						<div>{nl2br(order.notes)}</div>
					</div>
				)}

				{order.is_pickup !== 0 && (
					<div className="order-info--pickup-note">
						* At least one of your items is a pickup product.
					</div>
				)}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		siteInfo: state.siteInfo
	};
};

export default connect(mapStateToProps)(Order);



// WEBPACK FOOTER //
// ./src/components/Order.js